import React from 'react';

const Field = ({ label, children }) => (
  <div>
    <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{label}</label>
    {children}
  </div>
);

export default function DcaSettingsFields({ values, inputClass, onUpdate, hint }) {
  const mode = values?.dcaTriggerMode || 'drop_or_timeout';

  return (
    <div className="grid grid-cols-2 gap-2">
      <Field label="DCA Splits">
        <input
          type="number"
          min="2"
          max="5"
          value={values?.dcaSplits || 2}
          onChange={(e) => onUpdate('dcaSplits', parseInt(e.target.value, 10) || 2)}
          className={inputClass}
        />
      </Field>
      <Field label="Trigger Mode">
        <select
          value={mode}
          onChange={(e) => onUpdate('dcaTriggerMode', e.target.value)}
          className={inputClass}
        >
          <option value="drop_or_timeout">Drop or skip (default)</option>
          <option value="drop">Drop only</option>
          <option value="time">Timer only</option>
        </select>
      </Field>
      {mode !== 'time' && (
        <Field label="Drop From Avg Entry (%)">
          <input
            type="number"
            step="1"
            min="1"
            max="50"
            value={values?.dcaDropPercent ?? 10}
            onChange={(e) => onUpdate('dcaDropPercent', parseInt(e.target.value, 10) || 10)}
            className={inputClass}
          />
        </Field>
      )}
      <Field label={mode === 'time' ? 'Interval (min)' : 'Min Wait (min)'}>
        <input
          type="number"
          min="1"
          max="120"
          value={mode === 'time' ? (values?.dcaIntervalMinutes || 5) : (values?.dcaMinWaitMinutes ?? values?.dcaIntervalMinutes ?? 5)}
          onChange={(e) => {
            const val = parseInt(e.target.value, 10) || 5;
            onUpdate(mode === 'time' ? 'dcaIntervalMinutes' : 'dcaMinWaitMinutes', val);
          }}
          className={inputClass}
        />
      </Field>
      {mode === 'drop_or_timeout' && (
        <Field label="Max Wait (min, then skip)">
          <input
            type="number"
            min="5"
            max="240"
            value={values?.dcaMaxWaitMinutes ?? 60}
            onChange={(e) => onUpdate('dcaMaxWaitMinutes', parseInt(e.target.value, 10) || 60)}
            className={inputClass}
          />
        </Field>
      )}
      <p className="col-span-2 text-[10px] text-gray-400 dark:text-gray-500">
        {hint || (mode === 'time'
          ? 'Adds on a fixed timer regardless of price.'
          : mode === 'drop'
            ? 'Waits for price to dip below avg entry before adding. Won\'t chase pumps.'
            : 'Adds on dip from avg entry after min wait. Skips remaining splits if no dip before max wait.')}
      </p>
    </div>
  );
}
